import React from 'react';
import EntityUpdater from '../EntityUpdater.js';
import { useSelector } from 'react-redux';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { selectMe } from '@debbie/cortex/dist/me/selectors.js';
import { InitiateDNSButton } from '../InitiateDNS.js';
const Websites = (props) => {
    const { heading, collector } = props;
    const exclusiveContent = useSelector(selectExclusiveContent);
    const me = useSelector(selectMe);
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, heading),
        React.createElement(EntityUpdater, { key: "website", entity: "website", collector: collector }),
        React.createElement(EntityUpdater, { key: "clientWebBase", entity: "clientWebBase", collector: collector, disabled: !(me && exclusiveContent?.includes(me.id)) }),
        React.createElement(EntityUpdater, { key: "debtorWebBase", entity: "debtorWebBase", collector: collector, disabled: !(me && exclusiveContent?.includes(me.id)) }),
        React.createElement(InitiateDNSButton, { collectorId: collector.collectorId })));
};
export default Websites;
//# sourceMappingURL=Websites.js.map